import { h, render } from 'preact';
import GalleryView from './views/gallery.view';
import FooterView from './views/footer.view';
import HeaderView from './views/header.view';

// require('./legacy-header-support');

export class App {
    constructor(selector) {
        this.rootElement = document.querySelector(selector);
    }

    get app() {
        return (
            <app-container>
                <HeaderView />
                <GalleryView />
                <FooterView />
            </app-container>
        );
    }

    init() {
        render(this.app, this.rootElement);
    }
}
